import { useEffect, useRef } from 'react';

import posthog from 'posthog-js';

import OutlookConnectionFailedModal from '@/components/common/OutlookConnectionFailedModal';
import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import useOutlookConnection, {
  getOutlookConnectionError,
} from '@/features/settings/queries/hooks/useOutlookConnection';

import useAuth from './useAuth';

export default function useOutlookConnectionError() {
  const { showModal } = useModal();
  const { broker } = useAuth();

  const hasShownModalRef = useRef<boolean>(false);

  const { data: outlook, isPending } = useOutlookConnection();

  useEffect(() => {
    if (isPending || !broker || hasShownModalRef.current) return;

    const connectionError = getOutlookConnectionError(outlook);
    const hasConnectionFailed = Boolean(connectionError && outlook?.connected);

    if (!hasConnectionFailed) return;

    hasShownModalRef.current = true;

    posthog.capture('Outlook connection error shown', {
      error: connectionError,
    });

    showModal(OutlookConnectionFailedModal);
  }, [broker, isPending, outlook, showModal]);
}
